export const DAY_IDS = [0, 1, 2, 3, 4, 5, 6] as const;

export const WEEKDAY_LABELS_RU = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const WEEKDAY_LABELS_EN = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

/**
 * Default labels (Russian) — kept for legacy callers. Prefer the lang-aware
 * `getWeekdayLabels(lang)` for new code.
 */
export const WEEKDAY_LABELS = WEEKDAY_LABELS_RU;

export function getWeekdayLabels(lang: 'ru' | 'en'): string[] {
  return lang === 'en' ? WEEKDAY_LABELS_EN : WEEKDAY_LABELS_RU;
}

export function maskBits(mask: number): number[] {
  return DAY_IDS.filter(i => (mask >> i & 1) === 1);
}
